// Module
var code = "<div class=\"js-time\" on-click=\"click\">{{.currentTime}}</div>";
// Exports
export default code;